import {StarIcon} from '@heroicons/react/solid'

import scrims from '../../assets/scrims.png'
import scouting from '../../assets/scouting.png'
import teamManagement from '../../assets/team-management.png'
import analyticsAndReports from '../../assets/analytics-and-reports.png'
import playerData from '../../assets/player-data.png'
import dataAsService from '../../assets/data-as-a-service.png'
import {useRef} from "react";

import emailJS from '@emailjs/browser';
import {useNavigate} from "react-router-dom";

emailJS.init(process.env.REACT_APP_USER_ID);

const WhatsInside = ({productType}) => {
    const email = useRef("")

    const navigate = useNavigate()

    return (
        <div className="bg-white pb-8 sm:pb-12 lg:pb-12">
            <div className="pt-8 overflow-hidden sm:pt-12 lg:relative lg:py-48">
                <div
                    className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl lg:grid lg:grid-cols-2 lg:gap-24">
                    <div>
                        <div>
                            <a className="inline-flex space-x-4">
                                <span
                                    className="rounded bg-indigo-50 px-2.5 py-1 text-xs font-semibold text-indigo-600 tracking-wide uppercase">
                                    {productType === 5 && (
                                        'NEW 🎉'
                                    )}

                                    {productType !== 5 && (
                                        'SOON'
                                    )}
                                </span>
                            </a>
                        </div>

                        <div className="mt-6 sm:max-w-xl">
                            <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                                {productType === 0 && (
                                    <span>Organize scrims with just few clicks</span>
                                )}

                                {productType === 1 && (
                                    <span>Find high potential players all around the world</span>
                                )}

                                {productType === 2 && (
                                    <span>See your numbers, stay on track</span>
                                )}

                                {productType === 3 && (
                                    <span>Track your progress and performance</span>
                                )}

                                {productType === 4 && (
                                    <span>Get detailed player data at ease</span>
                                )}

                                {productType === 5 && (
                                    <span>Empower your events with esports data</span>
                                )}
                            </h1>

                            <p className="mt-6 text-xl text-gray-500">
                                {productType === 0 && (
                                    <span>Scrims are the best way to bring your competitive play to the stage.</span>
                                )}

                                {productType === 1 && (
                                    <span>Introducing the newest way to scout for the next wonderkid. We take all the data from past performances and compares it to the current top performers to find the next breakout player.</span>
                                )}

                                {productType === 2 && (
                                    <span>We make it easy to track your team’s numbers from expenses to incomes to contract dates. Keep your team in order with less effort.</span>
                                )}

                                {productType === 3 && (
                                    <span>We offer robust data collection and advanced reports, giving teams the ability to track their progress and performance in near-real-time.</span>
                                )}

                                {productType === 4 && (
                                    <span>We provide detailed player data for your team, including in-game stats, win/loss records, heatmaps, and predictions for upcoming matchups.</span>
                                )}

                                {productType === 5 && (
                                    <span>Make your events more exciting for viewers by using esports data. Let us help you increase your reach and engagement on your esports events.</span>
                                )}
                            </p>
                        </div>

                        <form action="" method="POST" onSubmit={event => {
                            event.preventDefault()

                            emailJS.send(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_PRODUCT_TEMPLATE_ID,{
                                email: email.current.value,
                                send_to: email.current.value,
                                reply_to: "team@scoutli.co"
                            }).then(() => {
                                navigate("/thanks");
                            }).catch(() => {
                                navigate("/error");
                            });
                        }} className="mt-12 sm:max-w-lg sm:w-full sm:flex">
                            <div className="min-w-0 flex-1">
                                <label htmlFor="email" className="sr-only">
                                    Email address
                                </label>

                                <input
                                    ref={email}
                                    required
                                    id="email"
                                    type="email"
                                    name="email"
                                    className="block w-full border border-gray-300 rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm transition-colors focus:border-indigo-500 focus:ring-indigo-500"
                                    placeholder="Enter your email"
                                />
                            </div>

                            <div className="mt-4 sm:mt-0 sm:ml-3">
                                <button
                                    type="submit"
                                    className="block w-full rounded-md border border-transparent px-5 py-3 bg-brand text-base text-white shadow transition-colors hover:bg-indigo-600 sm:px-10"
                                >
                                    Contact Us
                                </button>
                            </div>
                        </form>

                        <div className="mt-6">
                            <div className="inline-flex items-center divide-x divide-gray-300">
                                <div className="flex-shrink-0 flex pr-5">
                                    <StarIcon className="h-5 w-5 text-yellow-400" aria-hidden="true"/>
                                    <StarIcon className="h-5 w-5 text-yellow-400" aria-hidden="true"/>
                                    <StarIcon className="h-5 w-5 text-yellow-400" aria-hidden="true"/>
                                    <StarIcon className="h-5 w-5 text-yellow-400" aria-hidden="true"/>
                                    <StarIcon className="h-5 w-5 text-yellow-400" aria-hidden="true"/>
                                </div>

                                <div className="min-w-0 flex-1 pl-5 py-1 text-sm text-gray-500 sm:py-3">
                                    <span className="font-medium text-gray-900">Rated 5 stars</span> by over{' '}

                                    <span className="font-medium text-indigo-600">100 beta users</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sm:mx-auto sm:max-w-3xl sm:px-6">
                    <div className="py-12 sm:relative sm:mt-12 sm:py-16 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                        <div
                            className="relative pl-4 -mr-0 sm:-mr-40 sm:mx-auto sm:max-w-3xl sm:px-0 lg:max-w-none lg:h-full lg:pl-12">
                            {productType === 0 && (
                                <img
                                    className="rounded-md ml-0 sm:ml-24"
                                    src={scrims}
                                    alt="Scrims"
                                />
                            )}

                            {productType === 1 && (
                                <img
                                    className="rounded-md mt-0 ml-0 sm:mt-24 sm:ml-24"
                                    src={scouting}
                                    alt="Scouting"
                                />
                            )}

                            {productType === 2 && (
                                <img
                                    className="rounded-md"
                                    src={teamManagement}
                                    alt="Team Management"
                                />
                            )}

                            {productType === 3 && (
                                <img
                                    className="rounded-md mt-0 ml-0 sm:mt-24 sm:ml-12"
                                    src={analyticsAndReports}
                                    alt="Analytics & Reports"
                                />
                            )}

                            {productType === 4 && (
                                <img
                                    className="rounded-md"
                                    src={playerData}
                                    alt="Player Data"
                                />
                            )}

                            {productType === 5 && (
                                <img
                                    className="rounded-md mt-0 sm:mt-32"
                                    src={dataAsService}
                                    alt="Data as a Service"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhatsInside;
